import React, {Component} from 'react';

class Multiline extends Component
{
    constructor(props)
    {
        super(props);

        this.sep = this.props.sep != null ? this.props.sep : ";";

        this.onChange = props.onChange;
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event)
    {
        let reg = new RegExp(this.sep, 'g');
        let value = event.target.value.replace(reg, "");
        let values = [];
        if(this.props.value != null)
            values = this.props.value.split(this.sep);
        let pos = event.target.getAttribute("data-pos");
        if(pos == "" || pos == null)
            return;
        pos = parseInt(pos);
        if(pos > values.length)
            values.push(value);
        else 
            values[pos] = value;

        let evt = {
            "target" : {
                "name" : this.props.name,
                "value" : values.join(this.sep)
            }
        }
        this.onChange(evt);
    }

    render()
    {
        let lines = [];
        let values = [];
        if(this.props.value != null)
            values = this.props.value.split(this.sep);
        for(let v in values)
        {
            let word = values[v];
            lines.push(
                <input type="text" pattern={ this.props.pattern } value={ word } data-pos={ v } className="form-control mb-1" onChange={ this.handleChange } />
            );
        }
        if(values.length < this.props.max || this.props.max == null)
        {
            lines.push(
                <input type="text" pattern={ this.props.pattern } data-pos={ values.length } className="form-control mb-1" onChange={ this.handleChange } />
            );
        }

        return (
            <div className="form-group">
                { lines }
            </div>
        );
    }



}

export default Multiline;


// WEBPACK FOOTER //
// ./src/Components/Multiline.js